const Identity = {
    baseUrl: '/infra/identity/v3',
    backUrl: window.location.origin + '/api/v1/user', // TODO: направить редирект xhr в статическую заглушку?

    getAuthUrl() {
        return `${this.baseUrl}/OS-FEDERATION/identity_providers/${this.provider}/protocols/${this.protocol}/auth`;
    },

    getTokensUrl() {
        return `${this.baseUrl}/auth/tokens`;
    },

    provider: 'idp_mcs',
    protocol: 'oidc',

    getLogoutUrl() {
        return `${this.baseUrl}/auth/OS-FEDERATION/identity_providers/${
            this.provider
        }/protocols/${
            this.protocol
        }/websso/redirect?logout=${encodeURIComponent(this.backUrl)}`;
    },
};

export const OpenStackIdentity = {
    authUrl: Identity.getAuthUrl(),
    logoutUrl: Identity.getLogoutUrl(),
    tokensUrl: Identity.getTokensUrl(),
};
